<form #formElem [formGroup]="form" class="form layout-col gap-24">
  <div class="f-section">
    <div class="f-section-title">
      <span>Tipo Task</span>
    </div>

    <div class="f-section-content">

      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Tipo di dato</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <p><i>Seleziona il tipo di misurazione da associare al task</i></p>
          <mat-form-field class="task-type-field" compact>
            <mat-select placeholder="Seleziona un tipo di misura" formControlName="measurementType" required>
              <mat-option *ngFor="let dType of availableCdTypes$ | async" [value]="dType.key">
                {{ dType.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>

  <div class="f-section">
    <div class="f-section-title">
      <span>Periodicità</span>
    </div>

    <div class="f-section-content">

      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Data del task</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <mat-form-field compact>
            <input matInput formControlName="startDate" [min]="today" [matDatepicker]="startDatePicker"
                   placeholder="Data d'inizio" required readonly />
            <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #startDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>


      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Esecuzioni</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <p><i>Specifica le ore in cui i task avranno luogo</i></p>

          <ul formArrayName="executions">
            <li *ngFor="let a of executionsControls.controls; let i = index" class="layout-col">
              <div [formGroupName]="i">
                <div>
                  <b>Esecuzione {{ i + 1 }}</b>

                  <ng-container *ngIf="i !== 0 || executionsControls.controls.length > 1">
                    <button mat-button type="button" color="warn" (click)="onRemoveExecution(i)" *ngIf="!isViewMode">
                      Rimuovi
                    </button>
                  </ng-container>
                </div>

                <div class="layout-row wrap" style="align-items: center; gap: 6px">
                  <span>Il task è previsto per le ore</span>

                  <div class="ion-input-container">
                    <ion-input type="time" formControlName="time" required class="short-input time-like">
                    </ion-input>
                  </div>
                  <!-- <mat-form-field compact>
                    <input
                      matInput
                      type="time"
                      placeholder="HH:MM"
                      formControlName="time"
                      required
                    />
                  </mat-form-field> -->

                  <span>nel seguente momento della giornata:</span>

                  <mat-form-field compact>
                    <mat-select placeholder="Momento della giornata" formControlName="moment">
                      <mat-option *ngFor="let item of DAY_MOMENTS | keyvalue: sortAlphabetically" [value]="item.key">
                        {{ item.value }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </li>
          </ul>

          <button mat-button type="button" color="primary" (click)="onAddExecution()" *ngIf="!isViewMode">
            <mat-icon svgIcon="plus"></mat-icon>
            <span>Aggiungi esecuzione</span>
          </button>
        </div>
      </div>


      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Periodicità</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <p><i>Definisci ogni quanto tempo il task dovrà essere ri-eseguito dal paziente</i></p>

          <div *ngIf="formValue.frequencyType === 'every_x_days'" class="layout-row"
               style="align-items: center; gap: 6px">
            <span>Il task dovrà essere ripetuto ogni</span>
            <mat-form-field compact>
              <input matInput type="number" min="1" formControlName="frequencyValue" />
            </mat-form-field>

            <mat-form-field compact>
              <mat-select placeholder="Unità di tempo" formControlName="frequencyUnit" required>
                <mat-option *ngFor="let item of EXAM_PERIODIC_UNIT" [value]="item.key">
                  {{ item.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
      </div>


      <div class="f-entry layout-row" *ngIf="formValue.frequencyType === 'every_x_days'">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Termine periodicità</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <p><i>Definisci fino a quando il task dovrà essere ripetuto</i></p>
          <mat-form-field compact>
            <input matInput formControlName="endDate" [min]="today" [matDatepicker]="endDatePicker"
                   placeholder="Data di termine" readonly />
            <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatePicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>


  </div>


  <div *ngIf="item && !AIFlag" class="f-section">
    <div class="f-section-title">
      <span>Storico</span>
    </div>

    <div class="f-section-content">
      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Storico</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <span *ngFor="let prescr of prescription">
            <b>{{ prescr.date | date: "dd/MM/yyyy, HH:mm" }}</b>: il task è stato
            <span [ngClass]="getClassOf(prescr.state)">{{ prescr.state }}</span> da
            <b>{{ prescr.doctor }}</b> della struttura <b>{{ prescr.structure }}</b> <br />
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="f-section">
    <div class="f-section-title">
      <span>Note</span>
    </div>

    <div class="f-section-content">

      <div class="f-entry layout-row">
        <div class="f-entry-title flex-20 flex-100-md">
          <span>Note</span>
        </div>
        <div class="f-entry-content flex-80 flex-100-md">
          <span><i>Note opzionali</i></span>

          <mat-form-field class="notes-field">
            <textarea matInput name="notes" #notesInput formControlName="notes" maxlength="10000"></textarea>
            <mat-hint align="end">{{ notesInput.value?.length || 0 }}/10000</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </div>
  </div>



</form>